import { graphql } from '@/generated/gql';

export const BASE_COMMODITY_LIST_QUERY = graphql(/* GraphQL */ `
  query BaseCommodityList(
    $offset: Int
    $limit: Int
    $filter: JSON
    $order: [CommoditySortOrder!]
    $skipExport: Boolean = false
  ) {
    commodities(offset: $offset, limit: $limit, filter: $filter, order: $order) {
      nodes {
        id
        name
        description
        externalId
        supplierCount
        supplierList @skip(if: $skipExport) {
          id
          name
        }
        contractCount
        contractList @skip(if: $skipExport) {
          id
          name
        }
        deliveryOnTimePercentage
        correctOrderPercentage
        deviatingPricePercentage
        deviatingQuantityPercentage
        deviatingPriceQuantityPercentage
        leadTime
        orderVolume
        orderVolumeYear
        orderCount
        orderCountYear
        links @skip(if: $skipExport) {
          title
          url
        }
        primaryCommodityGroup
        commodityGroupCount
        commodityGroupList @skip(if: $skipExport) {
          id
          name
        }
      }
      totalCount
    }
  }
`);
